import { render, staticRenderFns } from "./SidebarSubgroup.vue?vue&type=template&id=2398aa52&"
import script from "./SidebarSubgroup.vue?vue&type=script&lang=js&"
export * from "./SidebarSubgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports